import { render, staticRenderFns } from "./CellDtBooleanType.vue?vue&type=template&id=67c65252&scoped=true"
import script from "./CellDtBooleanType.vue?vue&type=script&lang=js"
export * from "./CellDtBooleanType.vue?vue&type=script&lang=js"
import style0 from "./CellDtBooleanType.vue?vue&type=style&index=0&id=67c65252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c65252",
  null
  
)

export default component.exports